// Subdomains reserved for platform use — they can never be claimed as a
// project slug. Shared with the backend validation logic (project creation
// should reject these as slugs) once that piece is implemented.
export const RESERVED_SUBDOMAINS = ["admin", "app", "api", "assets", "www"];
